<div class="ui-g-12 ui-md-12">
  <div *ngIf="!mostrar">
    <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="calculando">
    <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

  </div>
  <div *ngIf="mostrar" id="multiplerow">

    <p-table (sortFunction)="customSort($event)" [customSort]="true" [columns]="cols" [value]="control"
      selectionMode="multiple" [(selection)]="selectedProducts" [paginator]="true" [rows]="20" [autoLayout]="true">
      <ng-template pTemplate="caption">
        <div class="header-caption">
          <div class="buscador">
            <i class="fa fa-search" style="margin:4px 4px 0 0"></i>
            <input type="text" pInputText size="50" placeholder="Buscar..." [(ngModel)]="buscador"
              (input)="buscadorEspecial($event.target.value)" style="text-align: left;height: 34px;min-width: 230px;">
          </div>
          <!-- Seleccionar cliente -->
          <div style=" width: 300px !important;" id="clientes-search">
            <p-dropdown [options]="clientes.filtered" [(ngModel)]="clientes.selected" [filter]="true"
              placeholder="Seleccione">
            </p-dropdown>
          </div>

          <div class="nuevo">
            <button pButton type="button" label="Crear oferta" class="btn-success" (click)="creaOferta()"></button>
          </div>
        </div>
      </ng-template>

      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field">
            {{col.header}}
            <p-sortIcon *ngIf="col.field != 'opciones'" [field]="col.field" ariaLabel="Activate to sort"
              ariaLabelDesc="Activate to sort in descending order"
              ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-rowIndex="rowIndex">
        <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex">
          <td *ngFor="let col of columns">
            <div [ngSwitch]="col.field">
              <div *ngSwitchCase="'foto'">
                <div *ngIf="rowData.archivo1 && rowData.archivo1.length > 0">
                  <img [src]="urlUploadArticulo+rowData.archivo1" class="image_firma"
                    style="width:30px ;height: 30px; margin: 0;">
                </div>

              </div>
              <div *ngSwitchDefault>
                {{rowData[col.field]}}
              </div>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <ul>
          <li *ngFor="let art of selectedProducts" style="text-align: left">
            {{art.id + ' - ' + art.nombre + ' - ' + art.color + ' - ' + art.maceta + ' - ' + art.tamano}}
          </li>
        </ul>
      </ng-template>
    </p-table>
  </div>
</div>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-toast [style]="{marginTop: '80px'}"></p-toast>

<!-- OFERTA -->
<p-dialog header="OFERTA PACK" [(visible)]="showOferta" [contentStyle]="{width:'90vw','max-height':'90vh'}"
  (onShow)="scrollToTop($event)">

  <!-- id="html2canvasDiv" -->
  <div *ngIf="showOferta" style="margin-left: 20px; margin-right: 20px; width: 80vw !important;">
    <div class="registroDiv" id="html2canvasDivOferta">

      <div class="flex-row">
        <div id="logo-mark" class="logo">
          <img [src]="logoBase64" alt="log-vpe vpe vpe-app" />
        </div>
        <div id="info-client" class="info">
          <div *ngIf="!tituloEnAleman" style="text-align: right;">
            <p class="large">{{oferta?.nombre}}</p>
            <p class="large">{{oferta?.direccion}}</p>
            <p class="large">{{oferta?.cp}} - {{oferta?.poblacion}}</p>
            <p class="large">{{oferta?.provincia}}</p>
            <p class="large">{{oferta?.pais}}</p>
            <p class="large">{{oferta?.telefono}}</p>
          </div>
          <div *ngIf="tituloEnAleman" style="text-align: right;">
            <p class="large">{{oferta?.nombre}}</p>
            <p class="large">{{oferta?.direccion}}</p>
            <p class="large">{{oferta?.cp}} {{oferta?.poblacion}}</p>
            <p class="large">{{oferta?.provincia}}</p>
            <p class="large">{{oferta?.pais}}</p>
            <p class="large">{{oferta?.telefono}}</p>
          </div>
        </div>
      </div>
      <div>

        <div class="sub-title" *ngIf="!tituloEnAleman">
          <h4 class="title-table">OFERTA</h4>
          <p >Fecha: {{fecha_actual}} </p>
        </div>
        <div class="sub-title" *ngIf="tituloEnAleman">
          <h4 class="title-table">ANGEBOT</h4>
          <p>Datum: {{fecha_actual}} </p>
        </div>

        <p>DETAIL ARTIKEL</p>
        <!-- <p style="margin-left: 1rem;">Detalle artículos</p> -->
        <table class="registro-table" border="1">
          <thead>
            <th>Foto</th>
            <th>Pack</th>
            <th>Mix Paket</th>

          </thead>
          <tr *ngFor="let pack of oferta?.packs; let i = index">
            <td align="center" *ngIf="pack.imagen && pack.ancho > pack.alto"> <img [src]="pack?.imagen"
                onload="resizeImg(this, 150, 80);"></td>
            <td align="center" *ngIf="pack.imagen && pack.ancho <= pack.alto"> <img [src]="pack?.imagen"
                onload="resizeImg(this, 80, 150);"></td>
            <td *ngIf="!pack.imagen"></td>
            <td>{{pack?.nombre}}</td>

            <td>
              <table class="articulos" style="width: 100%;">
                <thead>
                  <th style="width: 12%">Prod.</th>
                  <th style="width: 22%">Artikel</th>
                  <th style="width: 22%">Beschreibung</th>
                  <th style="width: 8%">Topf.</th>
                  <th style="width: 8%">Stk/Mix</th>
                  <th style="width: 8%">Stk/CC</th>
                  <th style="width: 8%">Preis {{oferta.tipo_precio}}</th>
                </thead>
                <tr *ngFor="let articulo of oferta?.packs[i].articulos">
                  <td>{{articulo?.proveedor}}</td>
                  <td>{{articulo?.nombre}}</td>
                  <td>{{articulo?.descripcion}}</td>
                  <td>{{articulo?.maceta}}</td>
                  <td style="text-align: right;">{{articulo?.cantidad}}</td>
                  <td style="text-align: right;">{{articulo?.unidades_cc}}</td>


                  <td style="text-align: right;">
                    <span>
                      {{decimalFormat(articulo?.precio, 2, '.', ',', 3)}}€
                    </span>

                  </td>
                </tr>
              </table>
              <table style="width: 100%;">
                <tr
                  style="font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif; text-align: center;">
                  {{pack?.observaciones}}
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>

  </div>

  
  <p-footer>
    
    <div class="d-flex justify-content-center">
      <button class="btn btn-dark mx-2" (click)="showOferta = false;">Cerrar</button>
      <button class="btn btn-primary mx-2" (click)="printPDF();" [disabled]="isGeneratingCanvas">
        <i class="fa fa-print"></i>
        Imprimir
      </button>
      <button class="btn btn-danger mx-2" (click)="generateExcel();" [disabled]="isGeneratingCanvas">
        <i class="fa fa-file-excel-o"></i>
        Excel
      </button>
      <span *ngIf="isGeneratingCanvas">
        Generando pdf...
      </span>

      <br>
    </div>
  </p-footer>


</p-dialog>
